import { createSlice } from '@reduxjs/toolkit'
import { doc, setDoc } from 'firebase/firestore'
import { db } from '../firebase/config'

const initialState = {
  user: null,
  isAuthenticated: false,
  role: null,
  libraryItems: []
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      const userData = action.payload
      state.user = userData
      state.isAuthenticated = true
      state.role = userData.role
    },
    logout: (state) => {
      state.user = null
      state.isAuthenticated = false
      state.role = null
      state.libraryItems = []
    },
    setUserData: (state, action) => {
      const { role } = action.payload
      state.role = role
      
      // Ensure user data exists in Firestore
      if (state.user?.id) {
        const userRef = doc(db, 'users', state.user.id)
        setDoc(userRef, {
          role: state.role
        }, { merge: true })
      }
    },
    setLibraryItems: (state, action) => {
      state.libraryItems = action.payload
    }
  },
})

export const { 
  login, 
  logout, 
  setUserData,
  setLibraryItems
} = authSlice.actions

export default authSlice.reducer
